import { t } from '@lingui/macro';

import PlainTextCell from 'components/PlainTextCell';

import { DEALER_TEAM, FLEET } from 'utils/SentinelTeam/constants';

const SOURCE_TYPE_LABELS = {
  [DEALER_TEAM]: t`Service Provider`,
  [FLEET]: t`Fleet`,
};

type Props = {
  rowData: Pick<SentinelTeam, 'teamType' | 'scheduledForDeletionAt'>;
};

export default function TeamTypeCell({
  rowData: { teamType, scheduledForDeletionAt },
}: Props) {
  return (
    <PlainTextCell
      color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
      topLine={SOURCE_TYPE_LABELS[teamType]}
    />
  );
}
